module.exports = __webpack_public_path__ + "img/homepage-banners-mazda-compliant-infiniti.b0b1ea10.jpg";